var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.75C3.35786 15.75 0 12.3921 0 8.25C0 4.10786 3.35786 0.75 7.5 0.75C11.6421 0.75 15 4.10786 15 8.25C14.9955 12.3903 11.6403 15.7455 7.5 15.75ZM7.5 2.25C4.18629 2.25 1.5 4.93629 1.5 8.25C1.5 11.5637 4.18629 14.25 7.5 14.25C10.8137 14.25 13.5 11.5637 13.5 8.25C13.4963 4.93783 10.8122 2.25372 7.5 2.25ZM7.4625 10.875L3.75 7.1625L4.8105 6.102L7.4625 8.75325L10.1145 6.102L11.175 7.1625L7.4625 10.875Z",
    fill: "#49963B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerColored);
export default __webpack_public_path__ + "static/media/lowerColored.cb9750be6261bd2d2ecd41f8821441c0.svg";
export { ForwardRef as ReactComponent };